export const NCAA_SPORTS = [
  "Baseball",
  "Men's Basketball",
  "Women's Basketball",
  "Beach Volleyball",
  "Bowling",
  "Men's Cross Country",
  "Women's Cross Country",
  "Equestrian",
  "Men's Fencing",
  "Women's Fencing",
  "Field Hockey",
  "Football",
  "Men's Golf",
  "Women's Golf",
  "Men's Gymnastics",
  "Women's Gymnastics",
  "Men's Ice Hockey",
  "Women's Ice Hockey",
  "Men's Lacrosse",
  "Women's Lacrosse",
  "Men's Rifle",
  "Women's Rifle",
  "Men's Rowing",
  "Women's Rowing",
  "Rugby Sevens",
  "Men's Skiing",
  "Women's Skiing",
  "Men's Soccer",
  "Women's Soccer",
  "Softball",
  "Men's Swimming & Diving",
  "Women's Swimming & Diving",
  "Men's Tennis",
  "Women's Tennis",
  "Men's Track & Field (Indoor)",
  "Women's Track & Field (Indoor)",
  "Men's Track & Field (Outdoor)",
  "Women's Track & Field (Outdoor)",
  "Men's Volleyball",
  "Women's Volleyball",
  "Men's Water Polo",
  "Women's Water Polo",
  "Wrestling",
  "Esports",
  "Competitive Cheer",
  "Dance",
] as const;

export type NcaaSport = (typeof NCAA_SPORTS)[number];
